// src/index.js
import React from "react";
import ReactDOM from "react-dom/client"; // ✅ React 18+ uses 'react-dom/client'
import App from "./App";
import "./index.css"; // ✅ Import your global or Tailwind CSS styles

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
